import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-organization_manage",
  "use": "icon-organization_manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-organization_manage\">\r\n  <path d=\"M800 576a161 161 0 0 0-23.07 1.67l-77.11-106.13a240 240 0 1 0-344.26-0.64l-77.29 106.38A195.8 195.8 0 0 0 256 576a192 192 0 1 0 135.77 56.25 193.13 193.13 0 0 0-34.58-27.49l62.73-86.34a241.12 241.12 0 0 0 215.36 0.4L701.52 610A159.82 159.82 0 0 0 640 736c0 88.22 71.77 160 160 160s160-71.78 160-160-71.77-160-160-160zM256 880a112 112 0 1 1 112-112 112.12 112.12 0 0 1-112 112z m272-416c-88.22 0-160-71.78-160-160s71.77-160 160-160 160 71.78 160 160-71.78 160-160 160z m272 352a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80z\" p-id=\"2711\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/organization_manage.svg
// module id = SM7V
// module chunks = 215